import { Component } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
  selector: 'bnpp-indx-usdisclaimer',
  imports: [
    FormsModule
  ],
  templateUrl: './usdisclaimer.component.html',
  styleUrl: './usdisclaimer.component.scss',
  standalone:true
})
export class UsdisclaimerComponent {
  agreeConditions = false;
  rememberSettings = false;

  constructor(private router: Router) {}

  /** Called when the Validate button is clicked */
  onValidate(): void {
    // Both check‑boxes are already required (button disabled otherwise)
    this.router.navigate(['/home']);
  }

}
